import { render } from "./PageTemplate.vue?vue&type=template&id=1f3351ae&scoped=true&ts=true"
import script from "./PageTemplate.vue?vue&type=script&lang=ts"
export * from "./PageTemplate.vue?vue&type=script&lang=ts"

import "./PageTemplate.vue?vue&type=style&index=0&id=1f3351ae&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3351ae"]])

export default __exports__